export default "__VITE_ASSET__f8101d43__"